module.exports = __webpack_public_path__ + "static/img/gifted2.89ca548a.png";